import React from "react";
import { Carousel } from "antd";
import PackagesData from "./PackagesData";
import { LeftOutlined, RightOutlined, CheckCircleFilled } from "@ant-design/icons";

const Packages = ({sectionRefs}) => {
  const onChange = (currentSlide) => {
    // console.log(currentSlide);
  };
  const Arrow = ({ IconComponent, style, className, onClick }) => (
    <IconComponent style={style} className={className} onClick={onClick} />
  );

  return (
    <section
      id="Packages"
      ref={sectionRefs.Packages}
      className=" bg-[#fbfbfb] px-4 md:px-0 py-14 md:py-20 w-full z-[99]"
    >
      <div className="gravity-container flex flex-col gap-10 sm:gap-14">
        <h2 className="text-[32px] font-montserrat font-bold leading-[30px] text-[#c784f7] uppercase text-center">
          Snap Shutter Social Plans
        </h2>
        <div className="w-full sm:w-[94%] mx-auto">
          <Carousel
            afterChange={onChange}
            arrows
            // autoplay
            prevArrow={<Arrow IconComponent={LeftOutlined} />}
            nextArrow={<Arrow IconComponent={RightOutlined} />}
            slidesToShow={3}
            slidesToScroll={3}
            responsive={[
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                },
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                },
              },
            ]}
          >
            {PackagesData?.map((item, ind) => (
              <div
                key={ind}
                className="bg-[#363636] rounded-lg shadow-lg h-[410px]"
              >
                <div className="mb-8">
                  <h3 className="text-[18px] font-montserrat font-semibold text-center text-white px-6 py-5"> {item?.plan} </h3>
                  <h4 className="text-[16px] font-montserrat font-medium text-center text-white bg-[#c784f7] px-4 py-2"> {item?.package_title} </h4>
                  { item?.package_desc && <p className="mt-4 text-[15px] text-gray-400 text-center font-montserrat px-6">{item?.package_desc}</p> }
                </div>
                {/* <div className="mb-8">
                        <span className="text-5xl font-extrabold text-white">$0</span>
                        <span className="text-xl font-medium text-gray-400">/mo</span>
                    </div> */}
                <ul className="mb-8 space-y-3 text-gray-400 px-8">
                  {item?.includes_list?.map((list, index) => (
                    <li key={index} className="flex items-center gap-4 text-[14px]">
                        <CheckCircleFilled className="text-[18px] text-[#6dfe79]" />
                      {
                        list?.text ?
                            <pre title={list?.text} className="cursor-pointer font-montserrat"> {list?.title} </pre> :
                            <span className="font-montserrat">{list?.title}</span>
                      }
                    </li>
                  ))}
                </ul>
                {/* <a href="#" className="block w-full py-3 px-6 text-center rounded-md text-white font-medium bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-600 hover:to-purple-600">
                    Sign Up
                    </a> */}
              </div>
            ))}
          </Carousel>
        </div>
      </div>
    </section>
  );
};

export default Packages;


                    
 // transform hover:scale-105 transition duration-300